import { formatCurrency } from '@/app/utils/formatCurrency';
import { formatMoneyCurrency } from '@/shared/utils/formatMoneyDisplay';
import { parseTenThousandths } from '@/shared/utils/moneyArithmetic';
import type { PurchaseAmount } from '../types/agreements.types';

const MISSING = '—';

export const formatPurchaseAmount = (amount: PurchaseAmount): string => {
    if (amount === null) return MISSING;
    if (typeof amount === 'number') return formatCurrency(amount);
    return parseTenThousandths(amount) === null ? MISSING : formatMoneyCurrency(amount, 'GBP');
};
